import { getCurrentPlatform } from '@/helpers/Platform/Platform';

export async function loadHomeOwnerWidgetImageUrls(targetLocale: string): Promise<string[]> {
  const platform = getCurrentPlatform();
  const widgetUrls: string[] = [];

  for (let i = 1; i <= 4; i++) {
    try {
      const module = await import(
        `@/assets/images/landing-home-owner-world/how-widget-${platform}-${targetLocale}-${i}.svg?url`
      );
      widgetUrls.push(module.default);
    } catch (error) {
      console.error(`Failed to load widget ${i} for ${platform}-${targetLocale}:`, error);
    }
  }

  return widgetUrls;
}
